import ReactDOM from 'react-dom'

import './index.css'
import App from './App'

const rootEl = document.getElementById('root')

// Initialize theme from localStorage or system preference
const savedTheme = localStorage.getItem('theme')
const prefersDark =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
const theme = savedTheme || (prefersDark ? 'dark' : 'light')
document.documentElement.setAttribute('data-theme', theme)

// Provide a simple global toggle for now
window.__toggleTheme = () => {
  const current = document.documentElement.getAttribute('data-theme')
  const next = current === 'dark' ? 'light' : 'dark'
  document.documentElement.setAttribute('data-theme', next)
  localStorage.setItem('theme', next)
}

ReactDOM.render(<App />, rootEl)
